export default "__VITE_ASSET__CJAJrNzI__"